var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flats-crm-card-map-container"},[_c('button',{staticClass:"btn-close-flats-crm-card-map",on:{"click":function($event){return _vm.$store.commit('openMapFlatsCrmCard', false)}}},[_c('svgIcon',{staticClass:"icon-close",attrs:{"name":"close"}})],1),_c('div',{staticClass:"map",attrs:{"id":"YmapComplexCrmCard"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }